import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { IMG } from "@/lib/images";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { EditorialMarquee } from "@/components/Marquee";
import { BookConsultation } from "@/components/BookConsultation";
import { SEO } from "@/components/SEO";
import { pageSEO } from "@/lib/seo";
import { useLang } from "@/i18n/LanguageContext";

export default function Evenementiel() {
  const { c, lang } = useLang();
  const e = c.pages.evenementiel;
  return (
    <div data-testid="evenementiel-page">
      <SEO {...pageSEO("evenementiel", lang)} path="/evenementiel" lang={lang} image={IMG.event} />
      <PageHeader eyebrow={e.eyebrow} lines={e.hLines} title="Événementiel" subtitle={e.subtitle} image={IMG.event} />
      <section className="py-24 lg:py-32 bg-olime-bg">
        <div className="container-olime grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-24 items-center">
          <Reveal><img src={IMG.event} alt="Événement" className="w-full aspect-[4/5] object-cover" /></Reveal>
          <div>
            <Reveal><span className="eyebrow">{e.secEyebrow}</span>
              <h2 className="font-serif text-4xl md:text-5xl tracking-tight mt-4">{e.secTitle}</h2></Reveal>
            <Reveal delay={0.15}>
              <p className="mt-6 text-olime-muted leading-relaxed">{e.secText}</p>
              <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
                {e.offers.map((o) => <li key={o} className="flex items-center gap-3 text-olime-ink"><Check size={15} className="text-olime-stone" /> {o}</li>)}
              </ul>
              <div className="mt-10 flex flex-wrap gap-4">
                <Link to="/contact?type=Event Design#form" data-testid="evenementiel-cta" className="btn-ink">{e.cta} <ArrowRight size={14} /></Link>
                <BookConsultation variant="outline" testId="evenementiel-book-cta" />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
      <EditorialMarquee words={e.marquee} dark />
    </div>
  );
}
